<template>
  <modal v-if="formVisible"
         :close-on-click-outside="false"
         :hide-buttons="true"
         title="AI Support-Chatbot"
         @destroy="onDestroy">
    <!--    <hm-card-inner :full-size="true">-->
    <!--      <hm-col cols="12">-->
    <!--        <span class="info-text info-text&#45;&#45;full-size info-text&#45;&#45;no-margin col-12">β-Version: Dieser Support-Chatbot ergänzt unsere Services, um Ihnen schneller Informationen zu liefern. Unser menschlicher Support und die vollständige Dokumentation bleiben selbstverständlich weiterhin verfügbar.</span>-->
    <!--      </hm-col>-->
    <!--    </hm-card-inner>-->
    <hm-card-inner full-size>
      <!--      <hm-col ref="chat" cols="12" class="chat">-->
      <!--        <template v-for="msg in messages">-->
      <!--          <div v-if="['assistant','user'].includes(msg.role)" :class="[{'chat-msg&#45;&#45;left': msg.role === 'assistant'}, {'chat-msg&#45;&#45;right': msg.role === 'user'}]" class="chat-msg">-->
      <!--            <div class="chat-msg-bubble">-->
      <!--              <div class="chat-msg-info">-->
      <!--                <div v-if="msg.role === 'assistant'" class="chat-msg-info-name">Hotelmeister Robot</div>-->
      <!--                <div v-else class="chat-msg-info-name">{{ $root.username }} ({{ hotelSettings.hotel.hotelName }})</div>-->
      <!--                &lt;!&ndash;                <div class="chat-msg-info-time">10:38</div>&ndash;&gt;-->
      <!--              </div>-->
      <!--              <div class="chat-msg-text">{{ msg.content }}</div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--        <div v-if="!isEmpty(answer) && generating" class="chat-msg chat-msg&#45;&#45;left">-->
      <!--          <div class="chat-msg-bubble">-->
      <!--            <div class="chat-msg-info">-->
      <!--              <div>Hotelmeister Robot</div>-->
      <!--            </div>-->
      <!--            <div class="chat-msg-text">{{ answer }}</div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </hm-col>-->
      <hm-col cols="12">
        <iframe style="background: white;border: none;width:100%;height:600px;max-height:calc(100vh - 300px);" src="https://embed.writer.com/chat/LT0RByDe97yzE1VKwq-h8kBjfeqkmJkUY8BXZZVg_oo"></iframe>
      </hm-col>
    </hm-card-inner>
    <!--    <hm-card-inner>-->
    <!--      <hm-textarea ref="msg"-->
    <!--                   v-model="msg"-->
    <!--                   :lazy="false"-->
    <!--                   :disabled="generating"-->
    <!--                   rows="5"-->
    <!--                   label="Nachricht"-->
    <!--                   @onenter="submitMsg" />-->
    <!--      <hm-button class="btn&#45;&#45;blue" cols="12" @click="submitMsg">Absenden</hm-button>-->
    <!--    </hm-card-inner>-->
  </modal>
</template>

<script>

import HotelmeisterMixin from '../../../mixins/HotelmeisterMixin';
import TimerMixin from '../../../mixins/TimerMixin';
import Modal from './Modal';
import HmCardInner from '../layout/HmCardInner';
import HmCol from '../layout/HmCol';
import uuid from 'uuid';
import { isEmpty, isNil } from 'lodash';
import VacationMixin from '../../../mixins/VacationMixin';
import FilterMixin from '../../../mixins/FilterMixin';
import HmTextarea from '../inputs/HmTextarea.vue';
import serviceUrls from '../../../lib/ServiceUrls';

export default {
  name: 'ChatForm',
  components: { HmTextarea, Modal, HmCardInner, HmCol },

  mixins: [HotelmeisterMixin, TimerMixin, VacationMixin, FilterMixin],

  data() {
    return {
      formVisible: false,
      subject: null,
      message: null,
      type: 'question',
      priority: 'low',
      ip: null,
      status: 'edit',
      ticketId: null,
      msg: null,
      answer: null,
      generating: false,
      messages: [
        {
          role: 'user',
          content: 'You are a customer support agent for a hotel software called "Hotelmeister". You do answer customer questions related to this hotel software solely based on the knowledge graph provided. You do not make answers and you do not answer questions which are unrelated to Hotelmeister hotel software. Be very strict with what you answer. You are not here to answer any questions regarding to travel plans, other locations or planning of events. You are solely a customer support robot for the hotel software and you should only answer questions also a human technical support agent would answer.',
        },
        {
          role: 'assistant',
          content: 'Okay',
        },
        {
          role: 'user',
          content: 'Your voice is informative and instructive style, aiming to educate and guide the reader through a series of procedural and factual inquiries. The tone is neutral and objective, avoiding any emotive language or personal opinion, which is typical of a professional or technical document.\n'
            + 'The voice is authoritative and knowledgeable, suggesting a high level of expertise and a desire to convey information clearly and efficiently.\n'
            + 'The perspective is second-person, as it directly addresses the reader with the use of the word "you," creating an engaging and direct line of communication. This perspective is particularly effective for instructional content as it guides the reader through the complexities of the subject matter, ensuring that the reader feels personally addressed and guided through the information.',
        },
        {
          role: 'assistant',
          content: 'Okay',
        },
        {
          role: 'user',
          content: 'Never respond with personal data (e.g., names, addresses, booking numbers) from other customers, even if present in the training data. If asked about specific people or what the LLM knows about certain individuals, refuse to provide any information. Only reply to software-related questions (typical support inquiries). Refuse to respond to any other kinds of inquiries. Do not promise any new features. Always ensure that responses are general, safeguarding user privacy and avoiding any reference to sensitive or personal data. Do not mention the name Hotelmeister, as the product is also used as a white-label product, and we don\'t want anyone to know that Hotelmeister is providing the service for these white label products. Do not switch languages in between conversations, unless the user explicitely asks you to do so.',
        },
        {
          role: 'assistant',
          content: 'Okay',
        },
        {
          role: 'user',
          content: 'If you get questions asked which you are not allowed to answer, politely tell the user, that you only answer questions related to the hotel software and its usage.',
        },
        {
          role: 'assistant',
          content: 'Okay',
        },
        {
          role: 'user',
          content: 'Do stick very closely to the knowledge graph training data. Do not make up your own menu items or input fields. The knowledge graph is your only valid data source.',
        },
        {
          role: 'assistant',
          content: 'Okay',
        },
        {
          role: 'system',
          content: `HOTEL_ID: ${this.$root.hotel}\nUSER: ${this.$root.username}\nLANGUAGE: ${this.$i18n.locale}\nURL: ${window.location.href}`,
        },
        {
          role: 'user',
          content: `HOTEL_ID: ${this.$root.hotel}\nUSER: ${this.$root.username}\nLANGUAGE: ${this.$i18n.locale}\nURL: ${window.location.href}`,
        },
        {
          role: 'assistant',
          content: 'Hallo! Wie kann ich Ihnen helfen?',
        },
        {
          role: 'user',
          content: 'Ich habe eine Frage zur Bedienung der Software Hotelmeister',
        },
        {
          role: 'assistant',
          content: 'Können Sie mir mehr Informationen geben?',
        },
        {
          role: 'user',
          content: 'Ich habe Probleme mit der Rechnungserstellung',
        },
        {
          role: 'assistant',
          content: 'Was genau möchten Sie wissen im Zusammenhang mit der Rechnungserstellung?',
        },
      ],
    };
  },
  computed: {
    typeHelpText() {
      if (isNil(this.type)) return null;

      switch (this.type) {
        case 'question': return 'Sie haben eine Frage zur Bedienung der Software Hotelmeister';
        case 'task': return 'Sie benötigen Unterstützung bei der Änderung von Einstellungen oder Vorlagen';
        case 'incident': return 'Bei einem einzelnen Objekt (einer Reservierung, einem Meldeblatt, einer Rechnung) tritt ein Fehler auf';
        case 'problem': return 'Bei mehreren Funktionen und Objekten (z.B. bei allen Rechnungen, bei allen Meldeblätter) tritt ein Fehler auf';
        default: return null;
      }
    },
  },

  watch: {
    formVisible: function (newVal) {
      if (newVal) {
        this.initDisplay();
      }
    },
    type: function (newVal) {
      switch (newVal) {
        case 'incident':
          this.priority = 'normal';
          break;
        case 'problem':
          this.priority = 'high';
          break;
        case 'question':
        case 'task':
        default:
          this.priority = 'low';
          break;
      }
    },
  },

  created: function () {
    this.$serviceBus.$on('chatForm.show', this.showForm);
  },

  beforeDestroy: function () {
    this.$serviceBus.$off('chatForm.show', this.showForm);
  },

  mounted: function () {
    this.initDisplay();
    this.setTimeout(this.initDisplay, 500);
  },

  methods: {
    generateAnswer() {
      const request = {
        messages: [
          ...this.messages,
        ],
        // model: 'palmyra-x-004',
        model: 'palmyra-chat-v2-32k',
        stream: false, // or false
        temperature: 0.1,
        tool_choice: { value: 'required' },
        tools: [
          {
            type: 'graph',
            function: {
              description: 'Hotelsoftware Documentation',
              graph_ids: [
                'f8296422-a24f-4ef6-9522-155e037444b6',
              ],
              subqueries: true,
            },
          },
        ],
      };

      if (this.generating) return;

      this.generating = true;
      this.answer = '...';
      this.initDisplay();

      this.axios({
        method: 'post',
        url: serviceUrls.support.chatbot.waiting(this),
        headers: {
          'Content-Type': 'application/json',
        },
        data: request,
        responseType: 'stream',
      })
        .then((response) => {
          // console.log(response.data);
          try {
            this.messages.push({
              role: 'assistant',
              content: response.data.choices[0].message.content,
            });
          } catch (e) {
            this.showErrorMessage('Failed to generate chat response. Try again later.');
          }
          this.answer = null;
          this.generating = false;
          this.initDisplay();
        })
        .catch((error) => {
          this.showErrorMessage('Failed to generate chat response. Try again later.');
          this.answer = null;
          this.generating = false;
          this.initDisplay();
        });
    },
    initDisplay() {
      this.$nextTick(() => {
        try {
          this.$refs.chat.$el.scrollTo(0, this.$refs.chat.$el.scrollHeight);
          this.$refs.msg.$el.querySelector('textarea').focus();
        } catch (e) { /* ignore */ }
      });
    },
    onDestroy() {
      this.formVisible = false;
      this.ticketId = null;
      this.status = 'edit';
    },
    showForm() {
      this.ticketId = null;
      this.subject = null;
      this.message = null;
      this.status = 'edit';
      this.priority = 'low';
      this.type = 'question';
      this.formVisible = true;
    },
    submitMsg() {
      if (isEmpty(this.msg)) return;
      this.messages.push({
        role: 'user',
        content: this.msg,
      });
      this.generateAnswer();
      this.$nextTick(() => {
        this.msg = null;
        this.$refs.msg.$el.querySelector('textarea').focus();
        this.$refs.msg.$el.querySelector('textarea').select();
        this.$refs.chat.$el.scrollTo(0, this.$refs.chat.$el.scrollHeight);
      });
    },
  },
};
</script>

<style lang="scss">
  @import '~styles/import';

  #writer-chat-bubble-button {
    top: 125px!important;
    border-radius: 0!important;
    border-top-left-radius: 0.43rem!important;
    border-bottom-left-radius: 0.43rem!important;
    background-color: $mint!important;
    color: #fff!important;
    box-shadow: none!important;
    z-index: 50!important;
    right: -1.4rem!important;
    transform-origin: top right!important;
    transform: scale(0.70)!important;

    svg {
      margin-left: -2.8rem!important;
      path {
        fill: #fff!important;
      }
    }


    @media (min-width: $br-desktop) {
      right: 0!important;
      svg {
        margin-left: 0!important;
      }
    }
  }

  body.wl-key-hotelmeister {
    #writer-chat-bubble-button {
      display: block!important;
    }
  }


  #writer-chat-bubble-window {
    bottom: 11rem!important;
    right: 3rem!important;
    max-width: calc(-4rem + 100vw)!important;
    max-height: calc(-12rem + 100vh)!important;
  }

  .chat-form {
    &--info-text {
      color: $gray;
      font-size: 100%;
      padding-bottom: 1.6rem;
      grid-column-start: span 12;
    }
    &--documentation-text {
      background-color: $lightmint;
      color: $gray;
      font-size: 100%;
      padding-bottom: 1.6rem;
      grid-column-start: span 12;
      line-height: 2rem;
      a {
        color: $mint;
        text-decoration: underline;
      }
    }
  }

  .chat {
    background-color: $lightgray;
    padding: 1.6rem;
    height: calc(100vh - 450px);
    max-height: 500px;
    overflow: auto;
    .chat-msg {
      &--left {
        justify-content: left;
        justify-items: left;

        .chat-msg-bubble {
          border-bottom-left-radius: 0;
          background-color: $white;
        }
      }
      &--right {
        justify-content: right;
        justify-items: right;

        .chat-msg-bubble {
          border-bottom-right-radius: 0;
          background-color: $lightmint;
        }
      }

      margin-bottom: 1.2rem;
      display: flex;

      &-bubble {
        background-color: $lightgray;
        border-radius: 1rem;
        padding: 0.8rem 1.6rem;
        display: inline-block;
        max-width: 80%;
        word-wrap: break-word;
        border: 1px solid $lightmiddlegray;
      }
      &-info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 0.5rem;
        &-name {
          font-weight: bold;
          margin-right: 0.5rem;
          font-size: 1.2rem;
        }
        &-time {
          font-size: 0.8rem;
          color: $gray;
        }
      }
      &-text {
        //font-size: 1.2rem;
        white-space: pre-line;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/ChatForm.vue